import * as React from "react";
import { createModule } from "../config.js";
import { EventsProvider, TimeoutsProvider } from "../contexts/index.js";
export const Core = ({ children }) => (React.createElement(TimeoutsProvider, null,
    React.createElement(EventsProvider, null, children)));
export const CoreModule = createModule("core", Core);
